import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { Server } from "miragejs"
import axios from 'axios';

import { layouts } from './Layout';
import * as themes from './themes';


let DevControls = () => null;

const url = new URL(window.location.href);
const isDevMode = url.searchParams.get('devmode');
const currentLayoutKey = url.searchParams.get('layout_key') || 'layout01';
const currentThemeKey = url.searchParams.get('theme_key') || 'light';
const currentMockName = url.searchParams.get('d') || 'withLinks';

const KNOWN_MOCKS = [ // List of mocks in `public/mocks`
  'australiaShipment',
  'canadaShipment',
  'delivered',
  'manyTrackingEvents',
  'missingBrandingConfig',
  'missingShipmentData',
  'missingTrackingData',
  'newZealandShipment',
  'oneLineItem',
  'threeLineItems',
  'twoLineItems',
  'ukShipment',
  'voided',
  'weightRounding',
  'withLinks'
];


if( isDevMode || window.Cypress ) {
  const mergeUrlParamData = (responseData) => {
    return {
      ...responseData,
      branding: {
        ...responseData.branding,
        layout_key: currentLayoutKey || responseData.branding.layout_key,
        theme_key: currentThemeKey || responseData.branding.theme_key
      }
    };
  };

  let server = new Server({
    routes() {
      this.get(`${process.env.REACT_APP_API_URL}track/:id`, (schema, fakeRequest) => {
        return new Promise( (resolve) => {
          const mockName = fakeRequest.params.id !== "null" ? fakeRequest.params.id : currentMockName;

          if( ! /^\w+$/.test( mockName ) ) { // Prevents URL attack. Keep simple, we can live with simple mock names
            throw new Error(`Invalid mock name '${mockName}'`);
          }

          axios.get(`/mocks/${mockName}.json`).then(
            response => resolve( mergeUrlParamData(response.data) ),
            () => { throw new Error(`No such mock '${mockName}'`); }
          );
        });
      });
    }
  });

  server.passthrough('/mocks/*');
}

if( isDevMode ) {
  const reloadWithConfig = (config) => {
    const d = config.mockName || currentMockName;
    const layout_key = config.layout_key || currentLayoutKey;
    const theme_key = config.theme_key || currentThemeKey;
    window.location = `/?devmode=1&d=${d}&layout_key=${layout_key}&theme_key=${theme_key}`;
  };

  const useStyles = makeStyles({
    root: {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      textAlign: 'right',
      background: '#eee',
      padding: '4px',
      borderRadius: '3px',
      boxShadow: '1px 1px 10px rgba(0,0,0,0.25)'
    }
  });

  DevControls = ({ data, setData }) => {
    const classes = useStyles();

    const onChangeLayout = (layout_key) => reloadWithConfig({ layout_key });
    const onChangeTheme = (theme_key) => reloadWithConfig({ theme_key });
    const onChangeMock = (mockName) => reloadWithConfig({ mockName });

    window.devMode = {
      ...(window.devMode || {}),
      data,
      setData
    };

    return <div className={classes.root}>
      <Select value={currentThemeKey} onChange={(e) => onChangeTheme(e.target.value)}>
        { Object.keys(themes).map( theme_key =>
          <MenuItem value={theme_key} key={theme_key}>{theme_key}</MenuItem>
        )}
      </Select>
      <br />
      <Select value={currentLayoutKey} onChange={(e) => onChangeLayout(e.target.value)}>
        { Object.keys(layouts).map( layout_key =>
          <MenuItem value={layout_key} key={layout_key}>{layout_key}</MenuItem>
        )}
      </Select>
      <br />
      <Select value={currentMockName} onChange={(e) => onChangeMock(e.target.value)}>
        { KNOWN_MOCKS.map( mockName =>
          <MenuItem value={mockName} key={mockName}>{mockName}</MenuItem>
        )}
      </Select>
    </div>;
  }
}

export default DevControls;